export const MANUAL_LOGOUT_STORAGE_KEY = 'admin-portal.manual-logout';
